export const quantitySelector = ({
    qty = 1,
    stock = null,
    maxQty = null,
    tracked = false,
    inBasketQty = 0,
    variantId = null,
    listenToBasket = true,
    isBasketPage = false,
}) => {
    return {
        qty,
        stock,
        maxQty,
        tracked,
        inBasketQty,
        variantId,
        listenToBasket,
        isBasketPage,
        _timeout: null,

        get max() {
            let limit = 999;

            if (this.tracked && this.stock !== null && this.maxQty !== null) {
                limit = Math.min(this.stock, this.maxQty);
            } else if (this.tracked && this.stock !== null) {
                limit = this.stock;
            } else if (this.maxQty !== null) {
                limit = this.maxQty;
            }

            // if (!this.isBasketPage) {
            //     limit -= this.inBasketQty;
            // }

            return Math.max(0, Math.min(limit, 999));
        },

        get remaining() {
            // On the basket page we need to ensure we don't go over the max but we also need to account for the in-basket quantity
            if (this.isBasketPage) {
                return this.max - this.qty;
            }

            // Otherwise we can just use the max minus the in-basket quantity - the current quantity of the input
            return Math.max(0, this.max - this.inBasketQty - this.qty);
        },

        get limitReason() {
            if (this.tracked && this.stock !== null && this.maxQty !== null) {
                const remaining = Math.min(this.stock, this.maxQty) - this.qty;

                return remaining <= 10 ? (this.maxQty < this.stock ? 'maxQty' : 'stock') : null;
            }

            if (this.tracked && this.stock !== null) {
                const remaining = this.stock - this.qty;

                return remaining <= 10 ? 'stock' : null;
            }

            if (this.maxQty !== null) {
                const remaining = this.maxQty - this.qty;

                return remaining <= 10 ? 'maxQty' : null;
            }

            return null;
        },

        get canAdd() {
            return this.qty <= this.max - this.inBasketQty;
        },

        get canIncrement() {
            return this.remaining > 0;
        },

        _dispatchQtyChanged() {
            clearTimeout(this._dispatchTimeout);
            this._dispatchTimeout = setTimeout(() => {
                this.$dispatch(`qty-changed-${this.variantId}`, {
                    qty: this.qty,
                    max: this.max,
                    inBasketQty: this.inBasketQty,
                    canAdd: this.canAdd,
                    remaining: this.max - this.inBasketQty,
                    maxReached: this.qty + this.inBasketQty > this.max,
                });
            }, 200);
        },

        init() {
            // Ensure we have the variant ID from the element
            if (!this.variantId && this.$el.dataset.variantId) {
                this.variantId = parseInt(this.$el.dataset.variantId);
            }

            // Store the variant ID as a data attribute for debugging
            this.$el.dataset.variantId = this.variantId;

            this.$watch('qty', (value) => {
                const parsed = parseInt(value) || 1;

                // Ensure qty doesn't exceed max
                // this.qty = parsed > this.max ? this.max : Math.max(1, parsed);
                // const remaining = this.max - this.inBasketQty;

                const limit = this.isBasketPage ? this.max : this.max - this.inBasketQty;

                this.qty = parsed > limit ? limit : Math.max(1, parsed);
                // this.qty = parsed > remaining ? remaining : Math.max(1, parsed);

                clearTimeout(this._timeout);
                this._timeout = setTimeout(() => {
                    if (this.$refs.qtyInput) {
                        htmx.trigger(this.$refs.qtyInput, 'updateForm');
                    }
                }, 1000);
            });

            // this.$watch('qty', (qty) => {
            //     this._dispatchQtyChanged();
            // });
            //
            // this.$watch('inBasketQty', () => {
            //     this._dispatchQtyChanged();
            // });

            this._dispatchQtyChanged();

            if (!this.listenToBasket) {
                return;
            }

            // Create a unique handler for this component instance
            const handleBasketNotifier = (event) => {
                const updated = event.detail;

                // Only process if this event is for our variant
                if (!this.isBasketPage && updated && updated.variantId === this.variantId) {
                    // Update the in-basket quantity
                    if (updated.cartQty !== undefined) {
                        // Use the explicit cart quantity from the event
                        this.inBasketQty = parseInt(updated.cartQty);
                    } else if (updated.qty) {
                        // Extract from qty string if necessary
                        const qtyMatch = updated.qty.match(/:\s*(\d+)/);

                        if (qtyMatch && qtyMatch[1]) {
                            this.inBasketQty = parseInt(qtyMatch[1]);
                        }
                    }

                    // If the current qty exceeds the new max, adjust it
                    if (this.qty > this.max && this.max > 0) {
                        this.qty = this.max;
                    }

                    // If we're at max capacity, disable further additions
                    if (this.max <= 0) {
                        console.log(`Max reached for variant ${this.variantId}`);
                    }

                    // if (this.max <= 0) {
                    //     console.log(`Max reached for variant ${this.variantId}`);
                    //
                    //     // window.dispatchEvent(new CustomEvent('basket:max-reached', {
                    //     //     detail: {
                    //     //         variantId: this.variantId,
                    //     //     },
                    //     // }));
                    // }
                }
            };

            // Store the handler reference so we can remove it later if needed
            this._basketHandler = handleBasketNotifier;

            // Add the event listener
            window.addEventListener('basket-notifier', this._basketHandler);

            // Clean up when the component is destroyed
            this.$cleanup = () => {
                window.removeEventListener('basket-notifier', this._basketHandler);
            };
        },
    };
};
